
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DynamicBasicInfoCard } from '../school-info/DynamicBasicInfoCard';
import { StageManagementCard } from '../academic/StageManagementCard';
import { AlertSettingsCard } from '../alerts/AlertSettingsCard';
import { SettingsSummaryCard } from './SettingsSummaryCard';
import { DataManagementCard } from '../data/DataManagementCard';
import { useState } from 'react';

interface SchoolSettingsTabsProps {
  settings: any;
  orderedStages: any[];
  tempSchoolName: string;
  setTempSchoolName: (name: string) => void;
  handleSaveSettings: () => void;
  updateSettings: (updates: any) => Promise<void>;
}

export const SchoolSettingsTabs = ({
  settings,
  orderedStages,
  tempSchoolName,
  setTempSchoolName,
  handleSaveSettings,
  updateSettings
}: SchoolSettingsTabsProps) => {
  const [activeTab, setActiveTab] = useState("basic");

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full" dir="rtl">
      <TabsList className="grid w-full grid-cols-2 sm:grid-cols-5 gap-1 sm:gap-2 mb-8 bg-white/70 backdrop-blur-sm p-1 h-auto">
        <TabsTrigger value="basic" className="text-xs sm:text-sm font-medium p-2 sm:p-3 whitespace-nowrap overflow-hidden text-ellipsis">المعلومات الأساسية</TabsTrigger>
        <TabsTrigger value="stages" className="text-xs sm:text-sm font-medium p-2 sm:p-3 whitespace-nowrap overflow-hidden text-ellipsis">المراحل والصفوف</TabsTrigger>
        <TabsTrigger value="alerts" className="text-xs sm:text-sm font-medium p-2 sm:p-3 whitespace-nowrap overflow-hidden text-ellipsis">إعدادات التنبيهات</TabsTrigger>
        <TabsTrigger value="data" className="text-xs sm:text-sm font-medium p-2 sm:p-3 whitespace-nowrap overflow-hidden text-ellipsis">إدارة البيانات</TabsTrigger>
        <TabsTrigger value="summary" className="text-xs sm:text-sm font-medium p-2 sm:p-3 whitespace-nowrap overflow-hidden text-ellipsis">ملخص الإعدادات</TabsTrigger>
      </TabsList>

      <TabsContent value="basic" className="space-y-6">
          <DynamicBasicInfoCard
            settings={settings}
            updateSettings={updateSettings}
          />
      </TabsContent>

      <TabsContent value="stages" className="space-y-6">
        <StageManagementCard 
          orderedStages={orderedStages} 
          updateSettings={updateSettings}
          settings={settings}
        />
      </TabsContent>


      <TabsContent value="alerts" className="space-y-6">
        <AlertSettingsCard 
          settings={settings}
          updateSettings={updateSettings}
        />
      </TabsContent>

      <TabsContent value="data" className="space-y-6">
        <DataManagementCard settings={settings} />
      </TabsContent>

      <TabsContent value="summary" className="space-y-6">
        <SettingsSummaryCard settings={settings} />
      </TabsContent>
    </Tabs>
  );
};
